import { AllFilterType } from "../CommonComponents/custom_filter/types";
import { SCENARIO_DEPLOYMENT_TYPES, SCENARIO_OPERATION_TYPES, SCENARIO_STATUS, SCENARIO_STEPS } from "./constants";
import { FormGroupDetailsType } from "./my-scenario/utils/scenario-types";
import { BusSvg, DetailsSvg, PayloadSvg } from "./svgs/Svgs";
import { SatelliteGroupType, ScenarioResponseType } from "./types";

export const get_formated_time = (time: number) => {
    const date = new Date(time * 1000);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');

    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
}

export const NAVIGATION_ITEMS = [
    {
        id: 1,
        name: 'Details',
        icon: <DetailsSvg />
    },
    {
        id: 2,
        name: 'Payload',
        icon: <PayloadSvg />
    },
    {
        id: 3,
        name: 'Bus',
        icon: <BusSvg />
    }
]

export const getFilterOption = (scenarios: ScenarioResponseType[]) => {
    const scenarioList = Array.isArray(scenarios) ? scenarios : []

    const satelliteOptions = scenarioList
        .flatMap(scenario => Array.isArray(scenario?.satelliteGroups) ? scenario.satelliteGroups : [])
        .flatMap(satelliteGroup => Array.isArray(satelliteGroup?.satellites) ? satelliteGroup.satellites : [])
        .reduce((unique: Array<{ label: string; value: string }>, satellite) => {
            if (!unique.some(item => item.value === satellite.satelliteName)) {
                unique.push({
                    label: satellite.satelliteName,
                    value: satellite.satelliteName
                });
            }
            return unique;
        }, []);

    const operator = {
        enabledSearch: false,
        multiselection: false,
        placeholder: 'Operator',
        options: [
            {
                label: '= Equals',
                value: '= Equals'
            },
            {
                label: '≠ not Equals',
                value: '≠ not Equals'
            },
        ]
    }

    const options = {
        enabledSearch: true,
        placeholder: 'Property',
        options: [
            {
                label: 'Type',
                value: 'Type',
                operator: operator,
                properties: {
                    enabledSearch: false,
                    multiselection: true,
                    placeholder: 'Value',
                    options: [
                        {
                            label: 'SWIL',
                            value: 'SWIL'
                        },
                        {
                            label: 'HWIL',
                            value: 'HWIL'
                        },
                        {
                            label: 'Quick Deploy',
                            value: 'Quick Deploy'
                        },
                        {
                            label: 'Manual',
                            value: 'Manual'
                        },
                    ]
                }
            },
            {
                label: 'Status',
                value: 'Status',
                operator: operator,
                properties: {
                    enabledSearch: false,
                    multiselection: true,
                    placeholder: 'Value',
                    options: [
                        {
                            label: 'Draft',
                            value: 'Draft'
                        },
                        {
                            label: 'Run Simulation',
                            value: 'Run Simulation'
                        },
                        {
                            label: 'In-Progress',
                            value: 'In-Progress'
                        },
                        {
                            label: 'Running',
                            value: 'Running'
                        },
                        {
                            label: 'Completed',
                            value: 'Completed'
                        }
                    ]
                }
            },
            {
                label: 'Satellite',
                value: 'Satellite',
                operator: operator,
                properties: {
                    enabledSearch: true,
                    multiselection: true,
                    placeholder: 'Value',
                    options: satelliteOptions || []
                }
            }
        ]

    }
    return options
}


export const handleApplyFilters = (scenarios: ScenarioResponseType[], filters: AllFilterType) => {
    let allScenarios: ScenarioResponseType[] = scenarios;
    const Types = {
        'SWIL': 'SIMULATE',
        'HWIL': 'HARDWARE_IN_LOOP',
        'Quick Deploy': 'QUICK_DEPLOY',
        'Manual': 'GENERIC_SIMULATE',
        'Open Scenario': 'TRUETWIN_COMMAND_CENTER'
    }
    const Status = {
        'Draft': 'Yes',
        'Run Simulation': 'ReadyForSimulation',
        'In-Progress': ['DeploymentInProgress', 'UnDeployInProgress'],
        'Running': 'SimulationRunning',
        'Completed': 'SimulationCompleted',
        'Redeploy': 'RedeployScenario'
    }

    if (filters?.searchFilter) {
        let updatedScenarios: ScenarioResponseType[] = [];
        allScenarios.filter(scenario => {
            if (scenario.scenarioName.toLowerCase().includes(filters?.searchFilter?.toLowerCase() as string)) {
                updatedScenarios.push(scenario);
            }
        })
        allScenarios = updatedScenarios;
    } if (filters?.advanceFilters) {
        filters?.advanceFilters.forEach(filter => {
            const { value, operator, properties } = filter;

            const updatedValues = typeof value === 'string' ? [value] : value;
            if (properties === 'Type') {
                let updatedScenarios: ScenarioResponseType[] = [];
                const types = updatedValues.map(value => Types[value as keyof typeof Types]);
                allScenarios.filter(scenario => {
                    if (operator === '= Equals' && types?.includes(scenario?.scenarioDeploymentType)) {
                        updatedScenarios.push(scenario);
                    } else if (operator === '≠ not Equals' && !types?.includes(scenario?.scenarioDeploymentType)) {
                        updatedScenarios.push(scenario);
                    }
                })
                allScenarios = updatedScenarios;
            } else if (properties === 'Status') {
                let updatedScenarios: ScenarioResponseType[] = [];
                if (operator === '= Equals') {
                    updatedValues.forEach(value => {
                        const key = value === 'Draft' ? 'draftMode' : 'status';
                        const status = Status[value as keyof typeof Status]; //completed
                        allScenarios.filter(scenario => {
                            if (operator === '= Equals' && status?.includes(scenario[key])) {
                                updatedScenarios.push(scenario);
                            }
                        })
                    })
                } else if (operator === '≠ not Equals') {
                    // Separate exclude lists by key
                    const exclude = {
                        status: new Set<string>(),
                        draftMode: new Set<string>()
                    };

                    // Build exclude lists
                    updatedValues.forEach(val => {
                        const status = Status[val as keyof typeof Status];
                        const values = Array.isArray(status) ? status : [status];

                        const key = val === "Draft" ? "draftMode" : "status";
                        values.forEach(v => exclude[key].add(v));
                    });

                    // Filter scenarios
                    allScenarios.forEach(scenario => {
                        const isExcluded =
                            exclude.status.has(scenario.status) ||
                            exclude.draftMode.has(scenario.draftMode);

                        if (!isExcluded) {
                            updatedScenarios.push(scenario);
                        }
                    });
                }
                allScenarios = updatedScenarios;
            } else if (properties === 'Satellite') {
                let updatedScenarios: ScenarioResponseType[] = [];
                allScenarios.filter(scenario => {
                    const satelliteNames = scenario.satelliteGroups.flatMap(satelliteGroup => satelliteGroup.satellites)
                        .reduce((unique: Array<string>, satellite) => {
                            if (!unique.some(item => item === satellite.satelliteName)) {
                                unique.push(satellite.satelliteName);
                            }
                            return unique;
                        }, []);
                    if (operator === '= Equals' && updatedValues.some(value => satelliteNames.includes(value))) {
                        updatedScenarios.push(scenario);
                    } else if (operator === '≠ not Equals' && updatedValues.forEach(value => !satelliteNames.includes(value))) {
                        updatedScenarios.push(scenario);
                    }
                })
                allScenarios = updatedScenarios;
            }

        })
    }
    return filters && Object.keys(filters)?.length > 0 ? allScenarios : scenarios;
}

export const getSatellitesCount = (satGroup: FormGroupDetailsType[] | SatelliteGroupType[]) => {
    let satCount = 0;
    satGroup?.map((group) => {
        satCount = satCount + Number(group?.satCount || group?.satelliteCount)
    })
    return satCount
}

export const getTooltipText = (status: string) => {
    switch (status) {
        case 'draft':
            return 'Click to Configure Scenario'
        case 'SimulationRunning':
            return 'Click to View Running Scenario'
        case 'SimulationCompleted':
            return 'Click to View Summary'
        case 'DeploymentInProgress':
            return 'Deployment In Progress'
        case 'UnDeployInProgress':
            return 'Undeployment In Progress'
        case 'RedeployScenario':
            return 'Redeploy Scenario'
        case 'WaitingForConnection':
            return 'Waiting For Connection'
        default:
            return 'Click to View and Deploy'
    }
}

export const getStatusTextMessage = (status: string) => {
    switch (status) {
        case 'draft':
            return 'Draft'
        case 'SimulationRunning':
            return 'Running'
        case 'SimulationCompleted':
            return 'Completed'
        case 'RedeployScenario':
            return 'Redeploy Scenario'
        case 'DeploymentInProgress':
            return 'Deploying'
        case 'UnDeployInProgress':
            return 'Undeploying'
        case 'WaitingForConnection':
            return 'Waiting For Connection'

        default:
            return 'Ready For Simulation'
    }
}

export const getDefaultHWILConfig = (payload: string, scenario: string = '{}') => {
    const scenario_data = JSON.parse(scenario)
    const selected_payload = JSON.parse(payload)
    const pins = selected_payload.interfaces || []
    const config = {}
    const all_scenario_payloads = scenario_data?.remoteAppConfiguration?.remoteApp?.AppData || []
    const matched_payload = Object.freeze(all_scenario_payloads.find((payload) => payload.id === selected_payload.id))
    const DefautlGpios = [
        {
            "port": "01",
            "pin": Array(4).fill(''),
            "interrupt": ""
        },
        {
            "port": "02",
            "pin": Array(4).fill(''),
            "interrupt": ""
        },
        {
            "port": "03",
            "pin": Array(4).fill(''),
            "interrupt": ""
        },
        {
            "port": "04",
            "pin": Array(4).fill(''),
            "interrupt": ""
        }
    ]
    config['gpio'] = matched_payload?.gpio || DefautlGpios
    config['gpioCount'] = matched_payload?.gpioCount || pins?.includes('GPIO') ? '1' : ''
    config['canPath0'] = matched_payload?.canPath0 || ''
    config['canPath1'] = matched_payload?.canPath1 || ''
    config['uartPath0'] = matched_payload?.uartPath0 || ''
    config['uartPath1'] = matched_payload?.uartPath1 || ''
    config['payloadDeviceIP'] = matched_payload?.payloadDeviceIP || ''
    return config
}

export const statusMap: Record<string, string> = {
    DeploymentInProgress: 'inprogress',
    UnDeployInProgress: 'undeploying',
    SimulationRunning: 'running',
    SimulationCompleted: 'completed',
    RedeployScenario: 'RedeployScenario',
};


export const getScenarioCurrentStep = (scenario: ScenarioResponseType) => {
    const status = scenario?.status
    const draftMode = scenario?.draftMode === 'Yes'
    const scenarioDeploymentType = scenario?.scenarioDeploymentType
    const scenarioOperation = scenario?.scenarioOperation
    const groups = scenario?.satelliteGroups || []
    const initialAltitude = scenario?.orientation || scenario?.angularRate
    const hwilComponents = scenario?.hwInfo || []
    const stations = scenario?.groundStations || []
    if (!groups?.length) return SCENARIO_STEPS.SATELLITES
    else if (scenarioOperation === SCENARIO_OPERATION_TYPES.LEOP && !initialAltitude) return SCENARIO_STEPS.INITIAL_ALTITUDE
    else if (scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.HARDWARE_IN_LOOP && !hwilComponents?.length) return SCENARIO_STEPS.HWIL
    else if (scenarioOperation === SCENARIO_OPERATION_TYPES.CONOPS && !stations?.length) return SCENARIO_STEPS.SEGMENTS
    else if (scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.TRUETWIN_COMMAND_CENTER) {
        return SCENARIO_STEPS.DEPLOY
    }
    else if (!draftMode) {
        if (scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.HARDWARE_IN_LOOP) {
            return status === SCENARIO_STATUS.HWIL_CONFIG_GENERATED ? SCENARIO_STEPS.CONNECT : status === SCENARIO_STATUS.WAITING_FOR_CONNECTION ? SCENARIO_STEPS.RECONNECT : SCENARIO_STEPS.ASSETS
        }
        return SCENARIO_STEPS.DEPLOY
    }
    return SCENARIO_STEPS.SCHEDULE
}


export const getScenarioBadgeType = (scenarioDeploymentType: typeof SCENARIO_DEPLOYMENT_TYPES[keyof typeof SCENARIO_DEPLOYMENT_TYPES]) => {
    return scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.TRUETWIN_COMMAND_CENTER ? 'TCC' : scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.HARDWARE_IN_LOOP ? 'SW+HW' : scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.SIMULATE ? 'SW' : 'QD'
}

export const getScenarioModeText = (deploymentType: string) => {
    switch (deploymentType) {
        case SCENARIO_DEPLOYMENT_TYPES.TRUETWIN_COMMAND_CENTER :
            return 'TCC'
        case SCENARIO_DEPLOYMENT_TYPES.HARDWARE_IN_LOOP:
            return 'SW+HW'
        case SCENARIO_DEPLOYMENT_TYPES.SIMULATE:
            return 'SW'
        case SCENARIO_DEPLOYMENT_TYPES.GENERIC_SIMULATE:
            return 'MN'
        case SCENARIO_DEPLOYMENT_TYPES.QUICK_DEPLOY:
            return 'QD'
        default:
            return 'QD'
    }
}
